/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import {basename, empty} from "@/util/util";

/**
 *
 * @class RegressionViewerMetadata
 *
 * metadata for the regression data related to a given corridor in a batch of corridors
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class RegressionViewerMetadata extends DocumentMetadata {

  /** the name */
  public name: string    = '';

  /** blob path for the regression (JSON) data */
  public blob: string    = '';

  /** standard constructor */
  constructor(
    id:          string     = '',
    title:       string     = '',
    blob:        string     = '',
    name:        string     = '',
    icon:        string     = '<i class="fa fa-chart-line"></i>',
    type:        WindowType = WindowType.RegressionViewer,
  ) {

    super(id, title, icon, type);

    this.name    = basename(blob);
    this.blob    = blob;

    if (!empty(name)) {

      this.name  = name;
    }

    if (empty(this.name)) {

      this.name  = title;
    }
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({name: this.name, blob: this.blob});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.name    = node.name;
    this.blob    = node.blob;
  }
}
